import Reservation       from "../../../domain/reservation/Reservation";
import ReservationDetail from "../../../domain/reservation/ReservationDetail";
import {
  ACTION_TYPE,
  ReservationAction,
  SetReservationAction,
  SetReservationCustomerAction,
  SetReservationDateAction,
  SetReservationFacilityAction,
  SetReservationStaffAction,
  SetReservationTimePeriodAction
}                        from "./ReservationAction";

const reservationReducer = (state: Reservation = new Reservation(), action: ReservationAction): Reservation => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_RESERVATION:
      return (action as SetReservationAction).reservation;
    case ACTION_TYPE.SET_RESERVATION_DATE:
      return new Reservation(
        state.id,
        new ReservationDetail(
          (action as SetReservationDateAction).date,
          state.detail.timePeriod,
        ),
        state.customer,
        state.staff,
        state.facility,
      );
    case ACTION_TYPE.SET_RESERVATION_TIME_PERIOD:
      return new Reservation(
        state.id,
        new ReservationDetail(
          state.detail.date,
          (action as SetReservationTimePeriodAction).timePeriod,
        ),
        state.customer,
        state.staff,
        state.facility,
      );
    case ACTION_TYPE.SET_RESERVATION_CUSTOMER:
      return new Reservation(
        state.id,
        state.detail,
        (action as SetReservationCustomerAction).customer,
        state.staff,
        state.facility,
      );
    case ACTION_TYPE.SET_RESERVATION_STAFF:
      return new Reservation(
        state.id,
        state.detail,
        state.customer,
        (action as SetReservationStaffAction).staff,
        state.facility,
      );
    case ACTION_TYPE.SET_RESERVATION_FACILITY:
      return new Reservation(
        state.id,
        state.detail,
        state.customer,
        state.staff,
        (action as SetReservationFacilityAction).facility,
      );
  }
};

export default reservationReducer;
